import { DashboardStore } from './dashboardStore';
import FirebaseStore from './firebaseStore';
import { UIStore } from './uiStore';
import { UserStore } from './userStore';

export class RootStore {
  private firebaseStore: FirebaseStore;
  public userStore: UserStore;
  public uiStore: UIStore;
  public dashboardStore: DashboardStore

  constructor() {
    this.firebaseStore = new FirebaseStore();
    this.userStore = new UserStore(this.firebaseStore);
    this.uiStore = new UIStore();
    this.dashboardStore = new DashboardStore(this.firebaseStore, this.userStore)
  }
}

export const rootStore = new RootStore();